/** The thread's routines by id (S-525), for their Made rows; null on an older Worker, which sends none. */
import { createContext } from "react";
import type { ThreadRoutine } from "../routines/api";

export const ThreadRoutines = createContext<Map<string, ThreadRoutine> | null>(null);
